import React, { useState } from "react";
import BookSearch from "./BookSearch.js";
import { MdDelete } from "react-icons/md";
import { Button, IconButton, Tooltip } from "@mui/material";

const BookRecommenderForm = ({
  recommendedBook,
  setRecommendedBook,
  selectedBooks,
  setSelectedBooks,
  recommendedBookLoading,
  getRecommendedBook,
}) => {
  const [searchingBookLoading, setSearchingBookLoading] = useState(false);

  const addSelectedBook = (selectedBook) => {
    setSelectedBooks((prevBooks) => {
      const isDuplicate = prevBooks.some((book) => book.id === selectedBook.id);
      return isDuplicate ? prevBooks : [...prevBooks, selectedBook];
    });
    setRecommendedBook(null);
  };

  const removeSelectedBook = (toRemoveBook) => {
    setSelectedBooks((prevBooks) =>
      prevBooks.filter((book) => book.id !== toRemoveBook.id)
    );
    setRecommendedBook(null);
  };

  const isAllBooksSelected = selectedBooks.length === 3;
  const isLoading = recommendedBookLoading || searchingBookLoading;
  const isButtonDisabled =
    (recommendedBookLoading || selectedBooks.length === 0) && !recommendedBook;

  const actionButtonText = () => {
    if (isLoading) return "Loading...";
    if (recommendedBook) return "View my rec";
    return "Get Recd";
  };

  const renderMainContent = () => {
    return selectedBooks.map((book, idx) => (
      <div key={book.id} style={bookCardStyle}>
        <img
          className="zoomOnHover"
          style={bookImageStyle}
          src={book.coverImage}
          alt={`Selected Book ${idx + 1}`}
        />
        <Tooltip title="Remove">
          <IconButton
            onClick={() => removeSelectedBook(book)}
            disabled={isLoading}
            sx={{
              backgroundColor: "#f44336",
              color: "white",
              "&:hover": {
                backgroundColor: "#d32f2f",
                transform: "scale(1.2)",
              },
              transition: "transform 0.2s ease-in-out",
              padding: "10px",
              marginTop: "10px",
            }}
          >
            <MdDelete />
          </IconButton>
        </Tooltip>
      </div>
    ));
  };

  return (
    <div style={containerStyle}>
      <div>
        <div style={{ height: "15px", color: "#2537A1", fontWeight: "800" }}>
          Discover Your Next Favorite Read—Instantly.
        </div>
        <h1 style={headingStyle}>Book Recommendations at Your Fingertips</h1>
      </div>
      <p style={subheadingStyle}>
        Enter up to 3 of your favorite or most recently read books.
      </p>

      <div style={{ width: "100%", marginTop: "20px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <BookSearch
            style={{ flexGrow: 1 }}
            selectedBooks={selectedBooks}
            isAllBooksSelected={isAllBooksSelected}
            addSelectedBook={addSelectedBook}
            loading={searchingBookLoading}
            isDisabled={recommendedBookLoading || isAllBooksSelected}
            setLoading={setSearchingBookLoading}
          />
        </div>
      </div>
      <div style={mainBodyStyle}>
        <div style={bookGridContainerStyle}>{renderMainContent()}</div>
      </div>
      <Tooltip
        title={
          selectedBooks.length === 0
            ? "You must add at least one book to get a recommendation."
            : ""
        }
      >
        <div>
          <Button
            onClick={getRecommendedBook}
            disabled={isButtonDisabled}
            sx={buttonStyle}
          >
            {actionButtonText()}
          </Button>
        </div>
      </Tooltip>
    </div>
  );
};

// Styles
const containerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: "20px",
  backgroundColor: "#F4F5FB",
  width: "100%",
  padding: "40px 20px",
};

const mainBodyStyle = {
  width: "100%",
  maxWidth: "600px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "20px",
};

const bookGridContainerStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
  gap: "20px",
  justifyItems: "center",
  width: "100%",
};

const bookCardStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px",
  width: "100px",
  height: "200px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  borderRadius: "8px",
  backgroundColor: "#fff",
  transition: "transform 0.2s ease-in-out",
};

const bookImageStyle = {
  width: "100%",
  height: "100px",
  objectFit: "cover",
  fontFamily: "Manrope, sans-serif",
  borderRadius: "8px",
};

const buttonStyle = {
  padding: "12px 24px",
  fontSize: "16px",
  fontWeight: "bold",
  borderRadius: "50px",
  background: "#37DDF6",
  fontFamily: "Manrope, sans-serif",
  color: "#fff",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#1AB8CC", // Darker version of #20EAFC
  },
};

const headingStyle = {
  fontSize: "48px",
  fontWeight: "800",
  color: "#101744",
  fontFamily: "Manrope, sans-serif",
};

const subheadingStyle = {
  fontSize: "28px",
  fontWeight: "500",
  color: "#223293",
  fontFamily: "Manrope, sans-serif",
};

export default BookRecommenderForm;
